/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Exit_History_ModeInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to exit history mode?" |
*
* @param {Confirm_Exit_History_ModeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const confirm_exit_history_mode = /** @type {((inputs?: Confirm_Exit_History_ModeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Exit_History_ModeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Are you sure you want\nto exit history mode?")
	return /** @type {LocalizedString} */ ("Êtes-vous sûr de vouloir\nquitter le mode historique ?")
});